import React, { useRef, useEffect, useState } from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { PopupMenu } from 'quantux-ui';
import { blue, gray, yellow } from '../../theme';

const CARD_WIDTH = 360;

const PracticeAccessManagerCard = (props) => {
  const [data, setData] = useState(props.data);
  const [selectedPrivilegeLevel, setSelectedPrivilegeLevel] = useState('');
  const [noAccessTabs, setNoAccessTabs] = useState([]);
  const [readTabs, setReadTabs] = useState([]);
  const [readWriteTabs, setReadWriteTabs] = useState([]);
  const [showMenu, setShowMenu] = useState(false);
  const [isMasterAdmin, setIsMasterAdmin] = useState(false);

  const menuRef = useRef();

  useEffect(() => {
    let usr = localStorage.getItem('usr');
    usr = JSON.parse(usr);
    if (usr) {
      setIsMasterAdmin(usr.isMasterAdmin);
    }
  }, []);

  useEffect(() => {
    setData(props.data);

    if (data.access) {
      const naTabs = [];
      const rTabs = [];
      const rwTabs = [];

      // Privilege level
      if (data.access.privilegeLevel) {
        const privilegeLevel = data.access.privilegeLevel;
        switch (privilegeLevel) {
          case 'basic':
            setSelectedPrivilegeLevel('Basic Privileges');
            break;
          case 'billing':
            setSelectedPrivilegeLevel('Billing Privileges');
            break;
          case 'credentialing':
            setSelectedPrivilegeLevel('Credentialing Privileges');
            break;
          case 'fullAdmin':
            setSelectedPrivilegeLevel('Full Admin Privileges');
            break;
          case 'custom':
            setSelectedPrivilegeLevel('Custom Privileges');
            break;
          default:
            setSelectedPrivilegeLevel('Select Privilege Level');
        }
      }

      // Profile
      if (data.access.profile === 0) {
        naTabs.push('Profile');
      } else if (data.access.profile === 4) {
        rTabs.push('Profile');
      } else {
        rwTabs.push('Profile');
      }

      // Case Ledger
      if (data.access.caseLedger === 0) {
        naTabs.push('Case');
      } else if (data.access.caseLedger === 4) {
        rTabs.push('Case');
      } else {
        rwTabs.push('Case');
      }

      // Payments Ledger
      if (data.access.paymentsLedger === 0) {
        naTabs.push('Payments');
      } else if (data.access.paymentsLedger === 4) {
        rTabs.push('Payments');
      } else {
        rwTabs.push('Payments');
      }

      // Credentialing
      if (data.access.credentialing === 0) {
        naTabs.push('Credentialing');
      } else if (data.access.credentialing === 4) {
        rTabs.push('Credentialing');
      } else {
        rwTabs.push('Credentialing');
      }

      // Insurance
      if (data.access.insurance === 0) {
        naTabs.push('Insurance');
      } else if (data.access.insurance === 4) {
        rTabs.push('Insurance');
      } else {
        rwTabs.push('Insurance');
      }

      // Providers
      if (data.access.providers === 0) {
        naTabs.push('Providers');
      } else if (data.access.providers === 4) {
        rTabs.push('Providers');
      } else {
        rwTabs.push('Providers');
      }

      // Collaborators
      if (data.access.collaborators === 0) {
        naTabs.push('Collaborators');
      } else if (data.access.collaborators === 4) {
        rTabs.push('Collaborators');
      } else {
        rwTabs.push('Collaborators');
      }

      // Facilities
      if (data.access.facilityCoverage === 0) {
        naTabs.push('Facilities');
      } else if (data.access.facilityCoverage === 4) {
        rTabs.push('Facilities');
      } else {
        rwTabs.push('Facilities');
      }

      // Access Manager
      if (data.access.accessManager === 0) {
        naTabs.push('Access Manager');
      } else if (data.access.accessManager === 4) {
        rTabs.push('Access Manager');
      } else {
        rwTabs.push('Access Manager');
      }

      setNoAccessTabs(naTabs);
      setReadTabs(rTabs);
      setReadWriteTabs(rwTabs);
    }
  }, [props.data]);

  const styles = StyleSheet.create({
    menuContainer: {
      background: '#0a3250',
      width: '150px'
    },
    menuItem: {
      height: '32px',
      borderBottom: '1px solid #001824',
      cursor: 'pointer',
      fontSize: '12px',
      background: gray[700]
      // background: selectedPrivilegeLevel === 'Basic Privileges' ? gray[900] : gray[700]
    },
    selectedMenuItem: {
      background: gray[900]
    },
    disabledMenuItem: {
      // color: 'black',
      // background: 'red'
      color: 'rgba(255, 255, 255, 0.25) !important',
      background: gray[700]
      // opacity: '0.5'
    }
  });

  return (
    <div
      key={data._id}
      className='p-2'
      style={{ width: `${CARD_WIDTH}px`, background: blue[700], borderRadius: '4px' }}
    >
      {/* Header */}
      <div
        className='fx'
        style={{ height: '40x', alignItems: 'center', justifyContent: 'space-between' }}
      >
        {/* Left side */}
        <div
          className='fx'
          style={{ alignItems: 'center' }}
        >
          <img
            src={data.avatarImageUrl}
            style={{ maxHeight: '32px', width: 'auto' }}
          />
          <div
            className='ml-2'
            style={{ fontSize: '12px', fontWeight: '700', color: blue[400] }}
          >
            <div>{`${data.lastName}, ${data.firstName}`}</div>
            <div>{`@${data.userName}`}</div>
          </div>
        </div>
        {/* Delete and Edit buttons */}
        {/* {props.premissionMode === 6 &&
          <div>
            <i
              className='fa fa-trash'
              onClick={() => props.onDeleteManager(data)}
            />
            <i
              className='ml-2 fa fa-cog'
              onClick={() => props.onEditPermissions(data)}
            />
          </div>
        } */}
      </div>
      {/* Privilege Level */}
      <div
        className='fx mt-3'
        style={{ alignItems: 'flex-start' }}
      >
        <div style={{ width: '32px', minWidth: '32px' }}>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none">
            <path fill="#00A0FF" fillRule="evenodd" d="M8 0C3.584 0 0 3.584 0 8s3.584 8 8 8 8-3.584 8-8-3.584-8-8-8Zm.8 12H7.2V7.2h1.6V12ZM7.2 5.6h1.6V4H7.2v1.6Z" clipRule="evenodd" />
          </svg>
        </div>
        <div
          className='ml-2 fx fx__v-center'
          style={{ fontSize: '12px', fontWeight: 'bold', color: blue[400], position: 'relative' }}
          ref={menuRef}
        >
          <div
            onClick={() => setShowMenu(true)}
            className='cursor__pointer'
          >
            {selectedPrivilegeLevel}
          </div>
          <i
            className='ml-2 fa fa-chevron-down cursor__pointer'
            onClick={() => setShowMenu(true)}
          />
          <PopupMenu
            top={28}
            left={11}
            zIndex='1550'
            position="absolute"
            visible={showMenu}
            parent={menuRef}
            onOutsideClick={() => setShowMenu(false)}
          >
            <div className={css(styles.menuContainer)}>
              {/* Basic Privileges */}
              <div
                className={`m-item ${css(styles.menuItem, selectedPrivilegeLevel === 'Basic Privileges' && styles.selectedMenuItem)}`}
                onClick={() => {
                  setShowMenu(false);
                  const tmpData = {
                    ...data,
                    access: {
                      caseLedger: 0,
                      paymentsLedger: 0,
                      insurance: 0,
                      profile: 4,
                      facilityCoverage: 0,
                      credentialing: 0,
                      providers: 0,
                      collaborators: 0,
                      accessManager: 0,
                      privilegeLevel: 'basic'
                    }
                  };
                  props.onChangePrivilegeLevel(tmpData);
                }}
              >
                Basic Privileges
              </div>
              {/* Billing Privileges */}
              <div
                className={`m-item ${css(styles.menuItem, selectedPrivilegeLevel === 'Billing Privileges' && styles.selectedMenuItem)}`}
                onClick={() => {
                  setShowMenu(false);
                  const tmpData = {
                    ...data,
                    access: {
                      caseLedger: 6,
                      paymentsLedger: 6,
                      insurance: 6,
                      profile: 4,
                      facilityCoverage: 4,
                      credentialing: 0,
                      providers: 0,
                      collaborators: 0,
                      accessManager: 0,
                      privilegeLevel: 'billing'
                    }
                  };
                  props.onChangePrivilegeLevel(tmpData);
                }}
              >
                Billing Privileges
              </div>
              {/* Credentialing Privileges */}
              <div
                className={`m-item ${css(styles.menuItem, selectedPrivilegeLevel === 'Credentialing Privileges' && styles.selectedMenuItem)}`}
                onClick={() => {
                  setShowMenu(false);
                  const tmpData = {
                    ...data,
                    access: {
                      profile: 6,
                      insurance: 6,
                      credentialing: 6,
                      facilityCoverage: 4,
                      caseLedger: 0,
                      paymentsLedger: 0,
                      providers: 0,
                      collaborators: 0,
                      accessManager: 0,
                      privilegeLevel: 'credentialing'
                    }
                  };
                  props.onChangePrivilegeLevel(tmpData);
                }}
              >
                Credentialing Privileges
              </div>
              {/* Full Admin Privileges */}
              <div
                className={`m-item ${!isMasterAdmin ? 'disabled' : ''} ${css(styles.menuItem, selectedPrivilegeLevel === 'Full Admin Privileges' && styles.selectedMenuItem, !isMasterAdmin && styles.disabledMenuItem)}`}
                onClick={() => {
                  if (isMasterAdmin) {
                    setShowMenu(false);
                    const tmpData = {
                      ...data,
                      access: {
                        profile: 6,
                        insurance: 6,
                        credentialing: 6,
                        caseLedger: 6,
                        facilityCoverage: 6,
                        paymentsLedger: 6,
                        providers: 6,
                        collaborators: 6,
                        accessManager: 4,
                        privilegeLevel: 'fullAdmin'
                      }
                    };
                    props.onChangePrivilegeLevel(tmpData);
                  }
                }}
              >
                Full Admin Privileges
              </div>
              {/* Custom Privileges */}
              <div
                className={`m-item ${!isMasterAdmin ? 'disabled' : ''} ${css(styles.menuItem, selectedPrivilegeLevel === 'Custom Privileges' && styles.selectedMenuItem, !isMasterAdmin && styles.disabledMenuItem)}`}
                onClick={() => {
                  if (isMasterAdmin) {
                    setShowMenu(false);
                    const tmpData = {
                      ...data,
                      access: {
                        profile: data.access.profile,
                        insurance: data.access.insurance,
                        credentialing: data.access.credentialing,
                        caseLedger: data.access.caseLedger,
                        facilityCoverage: data.access.facilityCoverage,
                        paymentsLedger: data.access.paymentsLedger,
                        providers: data.access.providers,
                        collaborators: data.access.collaborators,
                        accessManager: data.access.accessManager,
                        privilegeLevel: 'custom'
                      }
                    };
                    props.onChangePrivilegeLevel(tmpData);
                  }
                }}
              >
                Custom Privileges
              </div>
            </div>
          </PopupMenu>
        </div>
      </div>
      {/* Access */}
      <div className='mt-1'>
        {/* No Access */}
        <div
          className='fx'
          style={{ alignItems: 'flex-start' }}
        >
          <div style={{ width: '32px', minWidth: '32px' }}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="22"
              height="19"
              fill="none"
            >
              <path
                fill="#96C8FF"
                fillRule="evenodd"
                d="m3.281 3.55-2.28-2.28L2.27 0l17.738 17.73L18.74 19l-2.932-2.92-.42-.42c-1.35.54-2.831.84-4.382.84C6.003 16.5 1.731 13.39 0 9c.78-1.98 2.081-3.7 3.742-4.99l-.46-.46ZM16.007 9c0-2.76-2.24-5-5.002-5-.65 0-1.26.13-1.83.36L7.012 2.2c1.24-.45 2.581-.7 3.982-.7C15.997 1.5 20.269 4.61 22 9c-.73 1.86-1.92 3.49-3.432 4.75l-2.92-2.92c.23-.57.36-1.18.36-1.83ZM6.533 6.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.341 3 3.002 3 .22 0 .44-.03.65-.08l1.551 1.55c-.67.33-1.41.53-2.201.53a5.003 5.003 0 0 1-5.002-5c0-.79.2-1.53.53-2.2Zm7.463 2.37-3.151-3.15.17-.01c1.66 0 3.001 1.34 3.001 3l-.02.16Z"
                clipRule="evenodd"
              />
            </svg>
          </div>
          <div className='ml-2' style={{ fontSize: '12px', fontWeight: 'bold' }}>
            {noAccessTabs.join(', ')}
          </div>
        </div>
        {/* Read */}
        <div className='mt-1 fx fx__v-center'>
          <div style={{ width: '32px', minWidth: '32px' }}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="15"
              fill="none"
            >
              <path
                fill="#96C8FF"
                fillRule="evenodd"
                d="M10 0C5.455 0 1.573 3.11 0 7.5 1.573 11.89 5.455 15 10 15c4.546 0 8.427-3.11 10-7.5C18.427 3.11 14.546 0 10 0Zm0 12.5c-2.51 0-4.545-2.24-4.545-5s2.036-5 4.545-5c2.51 0 4.546 2.24 4.546 5s-2.037 5-4.546 5Zm-2.727-5c0-1.66 1.218-3 2.727-3 1.51 0 2.727 1.34 2.727 3s-1.218 3-2.727 3c-1.51 0-2.727-1.34-2.727-3Z"
                clipRule="evenodd"
              />
            </svg>
          </div>
          <div className='ml-2' style={{ fontSize: '12px', fontWeight: 'bold' }}>
            {readTabs.join(', ')}
          </div>
        </div>
        {/* Read/Write */}
        <div className='mt-1 fx fx__v-ceter'>
          <div style={{ width: '32px', minWidth: '32px' }}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              fill="none"
            >
              <path
                fill="#96C8FF"
                fillRule="evenodd"
                d="M17.707 2.632c.39.39.39 1.02 0 1.41l-1.83 1.83-3.749-3.75 1.83-1.83a.996.996 0 0 1 1.41 0l2.34 2.34ZM0 18v-3.75L11.059 3.193l3.749 3.75L3.749 18H0Z"
                clipRule="evenodd"
              />
            </svg>
          </div>
          <div
            className='ml-2' style={{ marginTop: '-4px', fontSize: '12px', fontWeight: 'bold' }}
          >
            {/* {readWriteTabs.join(', ')} */}
            {readWriteTabs.map((el, idx) => {
              if (el !== 'Access Manager') {
                return (
                  <span
                    key={Math.random().toString(36).slice(2)}
                    className='mr-1'
                  >
                    {`${el}${idx !== readWriteTabs.length - 1 ? ', ' : ''}`}
                  </span>
                );
              } else {
                return (
                  <span
                    key={Math.random().toString(36).slice(2)}
                    style={{ color: yellow[500] }}
                    className='mr-1'
                  >
                    {`${el}${idx !== readWriteTabs.length - 1 ? ', ' : ''}`}
                  </span>);
              }
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PracticeAccessManagerCard;
